import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const PaymentSummary = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [bottomMargin, setBottomMargin] = useState("0px");
  const [topMargin, setTopMargin] = useState("120px");
  const navigate = useNavigate();

  const customer = {
    name: "test test",
    phone: "06376794627",
    email: "test@gmail.com",
    state: "Rajasthan",
    address: "Ajmer - 305001",
    country: "India",
    city: "Ajmer",
  };

  const orderInfo = {
    id: 140,
    paymentMode: "N/A",
    created: "2025-10-03 10:32:52",
    updated: "2025-10-03 10:32:52",
    status: "Pending",
    currency: "INR",
  };

  const orderItems = [
    { name: "Yellow Sapphire - 7.52 Carat", price: 120601.61, qty: 1 },
    { name: "7 Mukhi Rudraksha", price: 3354.7, qty: 1 },
  ];

  const subtotal = orderItems.reduce((sum, item) => sum + item.price * item.qty, 0);
  const total = subtotal;

  const handlePayment = () => setShowSuccess(true);

  // Auto redirect after success
  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => navigate("/"), 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess, navigate]);

  // Responsive margins
  useEffect(() => {
    const updateMargins = () => {
      if (window.innerWidth <= 768) {
        setBottomMargin("0px"); // sticky at bottom
        setTopMargin("160px"); // mobile top spacing
      } else {
        setBottomMargin("0px");
        setTopMargin("120px");
      }
    };
    updateMargins();
    window.addEventListener("resize", updateMargins);
    return () => window.removeEventListener("resize", updateMargins);
  }, []);

  // Fireworks effect
  useEffect(() => {
    if (showSuccess) {
      const canvas = document.getElementById("fireworksCanvas");
      const ctx = canvas.getContext("2d");
      let fireworks = [];
      const colors = ["#FF5733", "#FFD700", "#00FFFF", "#FF00FF", "#00FF00", "#FFA500"];
      let width, height;

      const resize = () => {
        width = canvas.width = window.innerWidth;
        height = canvas.height = window.innerHeight;
      };
      resize();
      window.addEventListener("resize", resize);

      const random = (min, max) => Math.random() * (max - min) + min;

      class Firework {
        constructor(x, y) {
          this.x = x;
          this.y = y;
          this.particles = [];
          for (let i = 0; i < 80; i++) {
            const angle = (Math.PI * 2 * i) / 80;
            const speed = random(2, 6);
            this.particles.push({
              x: this.x,
              y: this.y,
              vx: Math.cos(angle) * speed,
              vy: Math.sin(angle) * speed,
              alpha: 1,
              color: colors[Math.floor(Math.random() * colors.length)],
            });
          }
        }
        update() {
          this.particles.forEach((p) => {
            p.x += p.vx;
            p.y += p.vy;
            p.vy += 0.03;
            p.vx *= 0.98;
            p.vy *= 0.98;
            p.alpha -= 0.015;
          });
          this.particles = this.particles.filter((p) => p.alpha > 0);
        }
        draw(ctx) {
          this.particles.forEach((p) => {
            ctx.globalAlpha = p.alpha;
            ctx.fillStyle = p.color;
            ctx.beginPath();
            ctx.arc(p.x, p.y, 2, 0, Math.PI * 2);
            ctx.fill();
          });
        }
      }

      const createFirework = () => {
        const x = random(width * 0.2, width * 0.8);
        const y = random(height * 0.2, height * 0.6);
        fireworks.push(new Firework(x, y));
      };

      const loop = () => {
        ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
        ctx.fillRect(0, 0, width, height);

        fireworks.forEach((f, i) => {
          f.update();
          f.draw(ctx);
          if (f.particles.length === 0) fireworks.splice(i, 1);
        });

        if (Math.random() < 0.06) createFirework();

        requestAnimationFrame(loop);
      };
      loop();

      return () => window.removeEventListener("resize", resize);
    }
  }, [showSuccess]);

  return (
    <>
      {/* Main Summary */}
      <div
        className="container"
        style={{
          paddingTop: topMargin,
          paddingBottom: "180px",
          maxWidth: "1100px",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <div className="row g-4">
          {/* LEFT */}
          <div className="col-md-8">
            <div className="bg-white p-4 rounded shadow-sm mb-4 border">
              <h5 className="fw-semibold mb-3 fs-xl">Customer & Shipping Details</h5>
              <div className="row">
                <div className="col-md-6 fs-lg">
                  <p><strong>Name:</strong> {customer.name}</p>
                  <p><strong>Phone:</strong> {customer.phone}</p>
                  <p><strong>State:</strong> {customer.state}</p>
                  <p><strong>Address:</strong> {customer.address}</p>
                </div>
                <div className="col-md-6 fs-lg">
                  <p><strong>Email:</strong> {customer.email}</p>
                  <p><strong>Country:</strong> {customer.country}</p>
                  <p><strong>City:</strong> {customer.city}</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded shadow-sm border">
              <h5 className="fw-semibold mb-3 fs-xl">Order Information</h5>
              <div className="row">
                <div className="col-md-6 fs-lg">
                  <p><strong>Order ID:</strong> {orderInfo.id}</p>
                  <p><strong>Payment Mode:</strong> {orderInfo.paymentMode}</p>
                  <p><strong>Created:</strong> {orderInfo.created}</p>
                </div>
                <div className="col-md-6 fs-lg">
                  <p><strong>Status:</strong> {orderInfo.status}</p>
                  <p><strong>Currency:</strong> {orderInfo.currency}</p>
                  <p><strong>Updated:</strong> {orderInfo.updated}</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="col-md-4">
            <div className="bg-white p-4 rounded shadow-sm border">
              <h5 className="fw-semibold mb-3 fs-xl">Order Summary</h5>
              {orderItems.map((item, index) => (
                <div key={index} className="mb-3 pb-2 border-bottom">
                  <p className="mb-1 fw-semibold fs-md">{item.name}</p>
                  <p className="mb-1 text-muted fs-md">
                    Price: ₹{item.price.toFixed(2)} × {item.qty}
                  </p>
                  <p className="mb-0 fw-semibold fs-md">
                    Total: ₹{(item.price * item.qty).toFixed(2)}
                  </p>
                </div>
              ))}
              <hr />
              <div className="d-flex justify-content-between fw-bold fs-lg">
                <span>Grand Total</span>
                <span>₹{total.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Glass Bar */}
      <div
        className="shadow-lg glass-bar border-top"
        style={{
          position: "fixed",
          bottom: bottomMargin,
          left: 0,
          width: "100%",
          zIndex: 1000,
          backdropFilter: "blur(14px)",
          background: "rgba(255, 255, 255, 0.95)",
          boxShadow: "0 -4px 25px rgba(0,0,0,0.1)",
          borderTop: "1px solid rgba(255,255,255,0.3)",
          padding: "16px 0",
          transition: "bottom 0.3s ease-in-out",
        }}
      >
        <div
          className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
          style={{ maxWidth: "1100px" }}
        >
          <div className="text-center text-md-start w-100 w-md-auto">
            <h5 className="fw-bold mb-1" style={{ fontSize: "1.9rem", letterSpacing: "0.4px" }}>
              TOTAL PAYABLE ({orderItems.length} Items)
            </h5>
            <p className="mb-0 fw-semibold" style={{ fontSize: "1.8rem", letterSpacing: "0.4px" }}>
              Total Amount: <span style={{ color: "#185E37", fontSize: "1.8rem" }}>₹ {total.toFixed(2)}</span>
            </p>
          </div>

          <button
            onClick={handlePayment}
            className="btn checkout-btn fw-semibold py-3 w-100 w-md-auto"
            style={{
              background: "#185E37",
              border: "none",
              color: "white",
              borderRadius: "50px",
              fontSize: "1.8rem",
              letterSpacing: "0.5px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.25)",
              transition: "all 0.3s ease",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            Make Payment
          </button>
        </div>
      </div>

      {/* SUCCESS POPUP WITH FIREWORKS */}
      {showSuccess && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.85)",
            zIndex: 2000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <canvas
            id="fireworksCanvas"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
            }}
          ></canvas>

          <div
            style={{
              position: "relative",
              background: "linear-gradient(145deg, #1a1a1a, #2a2a2a)",
              color: "#FFD700",
              textAlign: "center",
              padding: "40px",
              borderRadius: "25px",
              boxShadow: "0 0 60px rgba(255,215,0,0.6)",
              maxWidth: "400px",
              width: "90%",
              animation: "popUp 0.5s ease-out",
              zIndex: 10,
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                marginBottom: "15px",
                textShadow: "0 0 15px #FFD700, 0 0 35px #FFA500",
              }}
            >
              🪔
            </div>
            <h2
              style={{
                fontWeight: "bold",
                fontSize: "1.8rem",
                background: "linear-gradient(90deg, #FFD700, #FFA500)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              Payment Successful!
            </h2>
            <p
              style={{
                color: "#fff",
                fontSize: "1rem",
                marginTop: "10px",
                opacity: 0.8,
              }}
            >
              Thank you for your purchase. Your order has been placed successfully!
            </p>
            <button
              onClick={() => navigate("/")}
              style={{
                marginTop: "25px",
                background: "linear-gradient(90deg, #FFD700, #FFA500)",
                border: "none",
                borderRadius: "25px",
                padding: "10px 30px",
                color: "#000",
                fontWeight: "600",
                boxShadow: "0 0 20px #FFA500",
                cursor: "pointer",
              }}
            >
              Continue Shopping
            </button>
          </div>

          <style>{`
            @keyframes popUp {
              0% { transform: scale(0.6); opacity: 0; }
              100% { transform: scale(1); opacity: 1; }
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default PaymentSummary;
